var _defs, _rect, _text, _g, _line, _text2, _g2, _g3, _text3, _text4, _text5, _line2, _text6, _g4, _text7, _g5, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrtChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 560",
    width: 1000,
    height: 560,
    role: "img",
    "aria-label": "Predicting the sign of next-day returns from tabular features with a tree ensemble",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f6"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "qArrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#6c5ce7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 560,
    fill: "url(#qBg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 70,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.4,
    fill: "#6e6e73"
  }, "TABULAR FEATURES")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 88,
    width: 360,
    height: 200,
    rx: 10,
    fill: "#ffffff",
    stroke: "#d2d2d7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 118,
    x2: 420,
    y2: 118,
    stroke: "#d2d2d7"
  }), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#6e6e73",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 108
  }, "asset"), /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 108
  }, "x1"), /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 108
  }, "x2"), /*#__PURE__*/React.createElement("text", {
    x: 276,
    y: 108
  }, "x3"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 108
  }, "...")), /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#1d1d1f"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 144
  }, "A-014"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 144
  }, "0.31"), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 144
  }, "-1.02"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 144
  }, "0.77"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 144
  }, "..."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 172
  }, "A-058"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 172
  }, "-0.44"), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 172
  }, "0.19"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 172
  }, "-0.63"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 172
  }, "..."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 200
  }, "A-121"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 200
  }, "1.06"), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 200
  }, "0.52"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 200
  }, "0.08"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 200
  }, "..."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 228
  }, "A-197"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 228
  }, "-0.12"), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 228
  }, "-0.87"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 228
  }, "1.34"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 228
  }, "..."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 256
  }, "A-263"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 256
  }, "0.58"), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 256
  }, "0.04"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 256
  }, "-0.29"), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 256
  }, "...")), /*#__PURE__*/React.createElement("g", {
    stroke: "#eceff3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 156,
    x2: 420,
    y2: 156
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 184,
    x2: 420,
    y2: 184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 212,
    x2: 420,
    y2: 212
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 240,
    x2: 420,
    y2: 240
  })), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 310,
    fontSize: 12.5,
    fill: "#6e6e73"
  }, "278 asset allocations, lean and stable feature set"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 186,
    x2: 484,
    y2: 186,
    stroke: "#6c5ce7",
    strokeWidth: 2,
    markerEnd: "url(#qArrow)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 70,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.4,
    fill: "#6e6e73"
  }, "GRADIENT-BOOSTED TREES")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6c5ce7",
    strokeOpacity: 0.75,
    strokeWidth: 1.8,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566 102 L534 136 M566 102 L598 136 M534 136 L516 168 M534 136 L552 168 M598 136 L580 168 M598 136 L616 168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 102 L644 136 M676 102 L708 136 M644 136 L626 168 M644 136 L662 168 M708 136 L690 168 M708 136 L726 168"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#6c5ce7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 102,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 136,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 136,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 102,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644,
    cy: 136,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 136,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 168,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726,
    cy: 168,
    r: 4
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 748,
    y: 142,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 22,
    fill: "#6c5ce7",
    fillOpacity: 0.45
  }, "...")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 200,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 12.5,
    fill: "#6e6e73"
  }, "8-fold panel cross-validation")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 220,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 12.5,
    fill: "#6e6e73"
  }, "regime-aware post-processing")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 238,
    x2: 900,
    y2: 290,
    stroke: "#6c5ce7",
    strokeWidth: 2,
    markerEnd: "url(#qArrow)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 264,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.4,
    fill: "#6e6e73"
  }, "PREDICTED SIGN, NEXT DAY")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 298,
    width: 434,
    height: 124,
    rx: 10,
    fill: "#ffffff",
    stroke: "#d2d2d7"
  }), /*#__PURE__*/React.createElement("g", {
    fontSize: 13,
    fill: "#1d1d1f"
  }, /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 326
  }, "A-014"), /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 326,
    fill: "#2d6a4f",
    fontWeight: 700
  }, "+"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 326,
    fill: "#6e6e73",
    fontSize: 12
  }, "up"), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 354
  }, "A-058"), /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 354,
    fill: "#a63d40",
    fontWeight: 700
  }, "-"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 354,
    fill: "#6e6e73",
    fontSize: 12
  }, "down"), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 382
  }, "A-121"), /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 382,
    fill: "#2d6a4f",
    fontWeight: 700
  }, "+"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 382,
    fill: "#6e6e73",
    fontSize: 12
  }, "up"), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 410
  }, "A-197"), /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 410,
    fill: "#2d6a4f",
    fontWeight: 700
  }, "+"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 410,
    fill: "#6e6e73",
    fontSize: 12
  }, "up")), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 350,
    fontSize: 26,
    fontWeight: 700,
    fill: "#6c5ce7",
    textAnchor: "end"
  }, "52.3%"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 372,
    fontSize: 12.5,
    fill: "#6e6e73",
    textAnchor: "end"
  }, "out-of-sample accuracy"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 356,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.4,
    fill: "#6e6e73"
  }, "WHY IT IS HARD")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
    fill: "#1d1d1f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 382,
    r: 4,
    fill: "#6c5ce7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 387
  }, "a coin flip already scores 50 percent"), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 408,
    r: 4,
    fill: "#6c5ce7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 413
  }, "the edge sits in the second decimal"), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 434,
    r: 4,
    fill: "#6c5ce7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 439
  }, "overfitting is the default outcome"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 512,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 27,
    fontWeight: 700,
    letterSpacing: -0.5,
    fill: "#1d1d1f"
  }, "QRT Asset Allocation Challenge")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 540,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 17,
    fontWeight: 500,
    fill: "#6e6e73"
  }, "Top 10 percent of 967, predicting the sign of next-day returns from tabular data")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrtChallenge);
export default __webpack_public_path__ + "static/media/qrt_challenge.9001c9ba33bbbf4d9f57507571a67f54.svg";
export { ForwardRef as ReactComponent };